// extracted by mini-css-extract-plugin
export default {"splitter":"style-module--splitter--twdv-"};